import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import store from './store.js'
import './registerServiceWorker.js'

import '@/plugins/axios.js'
import '@/plugins/axios-progress-bar.js'
import '@/plugins/bootstrap-vue.js'
import '@/plugins/vue-toasted.js'
import '@/plugins/vue-auth.js'
import '@/plugins/vue-fontawesome.js'
import '@/plugins/vue-moment.js'
import '@/plugins/vue-async-computed.js'
import '@/plugins/lodash-globals.js'
import '@/plugins/vue-upload-component.js'
import '@/plugins/vue-papa-parse.js'
import '@/plugins/vue-currency-filter.js'
import '@/plugins/vue-html-to-paper.js'
// import '@/plugins/vue-json-pretty.js' // Habilitar para mostrar JSON de forma amigable

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
